/* FiND UX Audit Runtime — working theme only */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function smoothTo(target) {
    if (!target) return;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = target.getBoundingClientRect().top + window.scrollY - 84;
    window.scrollTo({ top: Math.max(top, 0), behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  function patchDutyNavigation() {
    if (!document.body.classList.contains('product-find-duty')) return;

    var nav = document.querySelector('[data-find-product-nav]');
    if (!nav) return;

    var flow = nav.querySelector('[data-find-nav-target="flow"]');
    var highlights = nav.querySelector('[data-find-nav-target="highlights"]');

    if (flow) {
      flow.textContent = 'Warum Duty?';
      flow.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        smoothTo(document.getElementById('duty-why'));
      }, true);
    }

    if (highlights) {
      highlights.textContent = 'System';
      highlights.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        smoothTo(document.querySelector('.find-duty-system'));
      }, true);
    }
  }

  function patchDutyDetails() {
    if (!document.body.classList.contains('product-find-duty')) return;

    var root = document.querySelector('[id^="FindDutyProductDetails-"]');
    if (!root) return;

    var contentBlocks = Array.prototype.slice.call(root.querySelectorAll('.find-duty-product-details__content'));
    var first = contentBlocks[0];

    if (first) {
      var intro = first.querySelector('p');
      if (intro) {
        intro.innerHTML = 'FiND Duty ist für vorbereitete Dienste aufgebaut. Die folgenden Inhalte erhältst du <strong>pro vorbereitetem Dienst</strong>:';
      }

      Array.prototype.slice.call(first.querySelectorAll('.find-duty-product-details__subheading')).forEach(function (heading) {
        var value = heading.textContent.replace(/\s+/g, ' ').trim().toUpperCase();

        if (value.indexOf('DEINE GEWÄHLTE DUTY-VARIANTE') !== -1) {
          var next = heading.nextElementSibling;
          heading.innerHTML = '<strong>DEINE DUTY-VARIANTE</strong><br>Je nach gewählter Variante bereitest du 5, 10 oder 15 Dienste vor.';
          if (next && next.tagName === 'UL') next.remove();
        }

        if (value.indexOf('QR-KARTE UND DIGITALER ZUGANG') !== -1 || value.indexOf('DIGITALER ZUGANG') !== -1) {
          heading.innerHTML = '<strong>DIGITALER ZUGANG</strong><br>Auf der Rückseite jeder Duty-Tüte findest du den QR-Code für deinen digitalen Start. Darüber erreichst du den Duty-Kompass sowie Mein FiND / die FiND App.';
        }

        if (value.indexOf('HYDROLOAD-GESCHMACKSAUSWAHL') !== -1 || value.indexOf('HYDROLOAD-GESCHMACK') !== -1) {
          heading.innerHTML = '<strong>HYDROLOAD-GESCHMACK</strong><br>Pro 5 vorbereitete Dienste wählst du eine Hydroload-Geschmacksrichtung. Duty 5: 1 Geschmack · Duty 10: 2 Geschmäcker · Duty 15: 3 Geschmäcker.';
        }
      });
    }

    contentBlocks.forEach(function (content) {
      var item = content.closest('.find-duty-product-details__item');
      var title = item && item.querySelector('.find-duty-product-details__item-heading');
      var heading = title ? title.textContent.trim() : '';
      var p = content.querySelector('p');

      if (heading === 'Für welche Dienste?' && p) {
        p.textContent = 'Duty ist für Menschen mit wiederkehrenden Schichten gedacht, die mehrere kommende Dienste vorbereitet abdecken möchten – unabhängig davon, ob du zum Beispiel in Pflege, Rettungsdienst, Polizei, Industrie, Logistik, Security oder einem anderen Schichtbereich arbeitest.';
      }

      if (heading === 'Digitaler Zugang' && p) {
        p.textContent = 'Auf der Rückseite jeder Duty-Tüte findest du den QR-Code für deinen digitalen Start. Darüber erreichst du den Duty-Kompass sowie Mein FiND / die FiND App und führst deine Duty-Routine digital weiter.';
      }
    });
  }

  function patchDutyFlavors() {
    if (!document.body.classList.contains('product-find-duty')) return;
    var root = document.querySelector('[data-duty-variant-cta]');
    if (!root) return;

    var intro = root.querySelector('.find-duty-hydroload__intro');
    if (intro) intro.textContent = '1 Geschmack gilt jeweils für 5 vorbereitete Dienste.';

    Array.prototype.slice.call(root.querySelectorAll('.find-duty-hydroload__legend span')).forEach(function (note) {
      if (/FiND Units|Duty Units|vorbereitete Dienste/i.test(note.textContent)) note.textContent = 'gilt für 5 vorbereitete Dienste';
    });

    var purchase = root.querySelector('.find-duty-variant-cta__purchase');
    if (purchase && !root.querySelector('.find-audit-quantity-label')) {
      var label = document.createElement('p');
      label.className = 'find-audit-quantity-label';
      label.textContent = 'Anzahl Sets';
      purchase.parentNode.insertBefore(label, purchase);
    }

    var saving = root.querySelector('[data-duty-savings]');
    if (saving && saving.textContent.indexOf('günstiger gegenüber dem Duty-5-Preisniveau') !== -1) {
      saving.textContent = saving.textContent.replace('günstiger gegenüber dem Duty-5-Preisniveau', 'günstiger als dieselbe Anzahl Dienste zum Duty-5-Preis');
    }
  }

  function patchDutyFaq() {
    if (!document.body.classList.contains('product-find-duty')) return;
    var root = document.querySelector('[id^="FindDutyFaq-"]');
    if (!root) return;

    var intro = root.querySelector('.find-duty-faq__intro');
    if (intro) {
      intro.innerHTML = '<p>Antworten zu Duty, Varianten, vorbereiteten Diensten, Hydroload-Auswahl, QR-Code, Versand und typischen Fragen vor und nach dem Kauf.</p>';
    }

    var hideQuestions = {
      'Was ist FiND Duty?': true,
      'Welche Duty-Variante passt zu mir?': true,
      'Was ist in einer Duty Unit enthalten?': true,
      'Für welche Dienste ist Duty gedacht?': true,
      'Sind alle Lebensmittel originalverpackt?': true
    };

    Array.prototype.slice.call(root.querySelectorAll('.find-duty-faq__item')).forEach(function (item) {
      var question = item.querySelector('.find-duty-faq__question');
      var answer = item.querySelector('.find-duty-faq__answer');
      if (!question) return;
      var q = question.textContent.trim();

      if (hideQuestions[q]) item.hidden = true;

      if (q === 'Wie funktioniert die persönliche QR-Karte?' || q === 'Wie funktioniert der QR-Zugang?') {
        question.textContent = 'Wie funktioniert der QR-Code?';
        if (answer) answer.innerHTML = '<p>Auf der Rückseite jeder Duty-Tüte findest du den QR-Code für deinen digitalen Start. Darüber erreichst du den Duty-Kompass sowie Mein FiND / die FiND App.</p>';
      }
    });

    Array.prototype.slice.call(document.querySelectorAll('script[type="application/ld+json"]')).forEach(function (script) {
      var raw = script.textContent || '';
      if (raw.indexOf('FAQPage') === -1 || raw.indexOf('FiND Duty') === -1) return;

      var entities = [];
      Array.prototype.slice.call(root.querySelectorAll('.find-duty-faq__item:not([hidden])')).forEach(function (item) {
        var q = item.querySelector('.find-duty-faq__question');
        var a = item.querySelector('.find-duty-faq__answer');
        if (!q || !a) return;
        entities.push({
          '@type': 'Question',
          name: q.textContent.trim(),
          acceptedAnswer: { '@type': 'Answer', text: a.textContent.replace(/\s+/g, ' ').trim() }
        });
      });

      script.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: entities });
    });
  }

  function patchCollectionCopy() {
    var root = document.querySelector('.find-collection-all');
    if (!root) return;

    var heroCopy = root.querySelector('.find-collection-all__hero > p:not(.find-collection-all__kicker)');
    if (heroCopy) {
      heroCopy.textContent = heroCopy.textContent
        .replace('Unit, der zu deiner Schicht passt', 'Produkt, das zu deiner Schicht passt')
        .replace('Unit, die zu deiner Schicht passt', 'Produkt, das zu deiner Schicht passt');
    }

    var introHeading = root.querySelector('.find-collection-all__system-intro h2');
    if (introHeading) introHeading.textContent = 'Nicht jeder Dienst braucht dasselbe FiND Produkt.';
  }

  ready(function () {
    patchDutyNavigation();
    patchDutyDetails();
    patchDutyFlavors();
    patchDutyFaq();
    patchCollectionCopy();

    var dutyRoot = document.querySelector('[data-duty-variant-cta]');
    if (dutyRoot) {
      var observer = new MutationObserver(function () { patchDutyFlavors(); });
      observer.observe(dutyRoot, { childList: true, subtree: true });
      document.addEventListener('find:duty-config-updated', patchDutyFlavors);
    }
  });
})();
